import { IFirstPaymentDefinition } from '../types/IFirstPaymentDefinition';

export interface IFirstPaymentDefinitionState {
    firstPaymentDefinitions: IFirstPaymentDefinition[];
}

export interface IFirstPaymentDefinitionMutations {
    setFirstPaymentDefinitions(state: IFirstPaymentDefinitionState, definitions: IFirstPaymentDefinition[] | undefined): void;
    resetFirstPaymentDefinitions(state: IFirstPaymentDefinitionState): void;
}

const firstPaymentDefinitionStore = {
    namespaced: true,
    state: {
        firstPaymentDefinitions: [],
    },
    mutations: {
        setFirstPaymentDefinitions(state: IFirstPaymentDefinitionState, definitions: IFirstPaymentDefinition[] | undefined): void {
            const existingIds = state.firstPaymentDefinitions.map((fpd) => fpd.id);
            const newDefinitions = definitions?.filter((fpd) => existingIds.indexOf(fpd.id) === -1) || [];
            if (newDefinitions.length) {
                state.firstPaymentDefinitions = [...state.firstPaymentDefinitions, ...newDefinitions];
            }
        },
        resetFirstPaymentDefinitions(state: IFirstPaymentDefinitionState): void {
            state.firstPaymentDefinitions = [];
        },
    },
    getters: {
        getEntities: (state: IFirstPaymentDefinitionState): IFirstPaymentDefinition[] => state.firstPaymentDefinitions,
    },
};

export const NAMESPACE = 'FirstPaymentDefinitionRepository';

export default firstPaymentDefinitionStore;
